import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { Layout } from '@domain-group/fe-co-allhomes-design-system';
import localityPropType from '../../proptypes/locality';
import AllhomesSearchSurroundingSuburbs from '../surrounding-suburbs/surrounding-suburbs';
import { SuburbInfoLinks } from './allhomes-listing-suburb-info-links';
import { OldPropertyAlertButton } from '../old-property-alert-button';
import * as styles from './allhomes-listing-search-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var researchPath = '/ah/research/';
var agentsPath = '/agents/results/';
var getSuburbInfoLink = (hostName, singleLocality) => {
  if (!singleLocality) {
    return '';
  }
  var suburbName = singleLocality.name;
  var suburbId = "".concat(singleLocality.id);

  // This should be handled by the URL-assembling Java code but we need a quick fix and these
  // research URLs should die soonish anyway.
  var sanitise = victim => victim.toLowerCase().trim().replace(/[\s_/,]/g, '-').replace(/[^a-z0-9-]/g, '').replace(/[-]{2,}/g, '-');
  return "".concat(hostName).concat(researchPath).concat(sanitise(suburbName), "/12").concat(suburbId, "10");
};
var getAgentsLink = (hostName, singleLocality) => {
  if (!singleLocality) {
    return '';
  }
  return "".concat(hostName).concat(agentsPath).concat(singleLocality.slug, "/");
};
var Footer = _ref => {
  var _ref$singleLocality = _ref.singleLocality,
    singleLocality = _ref$singleLocality === void 0 ? null : _ref$singleLocality,
    numberOfProperties = _ref.numberOfProperties,
    _ref$surroundingSubur = _ref.surroundingSuburbs,
    surroundingSuburbs = _ref$surroundingSubur === void 0 ? [] : _ref$surroundingSubur,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media,
    hostName = _ref.hostName,
    _ref$onPropertyAlertC = _ref.onPropertyAlertClick,
    onPropertyAlertClick = _ref$onPropertyAlertC === void 0 ? () => {} : _ref$onPropertyAlertC,
    _ref$listingCategory = _ref.listingCategory,
    listingCategory = _ref$listingCategory === void 0 ? '' : _ref$listingCategory;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var isBrowseDivision = singleLocality ? singleLocality.type === LocalityType.DIVISION.type : false;
  var suburbName = singleLocality ? singleLocality.name : '';
  return ___EmotionJSX(Layout.PageContainer, null, ___EmotionJSX(Layout.BodySection, {
    css: styles.bottomContent
  }, ___EmotionJSX("div", {
    css: styles.propertyAlertSection
  }, ___EmotionJSX("div", {
    css: styles.propertyAlert
  }, "Get notified when new properties matching your search criteria are listed on Allhomes"), ___EmotionJSX(OldPropertyAlertButton, {
    buttonLabel: "Create email alert for this search",
    onPropertyAlertClick: onPropertyAlertClick,
    targetUrl: getAbsoluteUrl('/research')
  })), isBrowseDivision && ___EmotionJSX(SuburbInfoLinks, {
    linkUrl: getSuburbInfoLink(hostName, singleLocality),
    agentLinkUrl: getAgentsLink(hostName, singleLocality),
    suburbName: suburbName,
    numberOfProperties: numberOfProperties,
    media: media
  }), isBrowseDivision && !isEmpty(surroundingSuburbs) && ___EmotionJSX("div", {
    css: styles.surroundingSuburbsWrapper
  }, ___EmotionJSX(AllhomesSearchSurroundingSuburbs, {
    name: suburbName,
    items: surroundingSuburbs,
    listingCategory: listingCategory
  }))));
};
Footer.propTypes = {
  singleLocality: localityPropType,
  numberOfProperties: PropTypes.number.isRequired,
  surroundingSuburbs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string
  })),
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    desktop: PropTypes.bool,
    tablet: PropTypes.bool
  }),
  hostName: PropTypes.string.isRequired,
  onPropertyAlertClick: PropTypes.func,
  listingCategory: PropTypes.string
};
export default Footer;